import { pipe, prop } from 'ramda';

export const getBrand = (state, route) => state.extensions.byRoute[route];

export const getBrandName = pipe(
  getBrand,
  prop('name'),
);

export const getBrandImage = pipe(
  getBrand,
  prop('backgroundImage'),
);

export const getBrandLogo = pipe(
  getBrand,
  prop('logoImage'),
);

export const getBrandShops = pipe(
  getBrand,
  prop('shops'),
);

export const getBrandBranchKey = pipe(
  getBrand,
  prop('branchKey')
);

export const getBrandId = pipe(
  getBrand,
  prop('brandId'),
);



// WEBPACK FOOTER //
// ./src/app/brands/selectors.js